import { render } from "./CrearFinalizadorModal.vue?vue&type=template&id=5fde4e36"
import script from "./CrearFinalizadorModal.vue?vue&type=script&lang=js"
export * from "./CrearFinalizadorModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__